// --- Formatea número a precio ---
function formatPrice(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

// --- Handler para swatch (separado para poder removerlo) ---
function swatchClickHandler() {
  const card = this.closest(".card");
  const productName = this.dataset.productName;
  const productUrl = this.dataset.productUrl;
  const price = Number(this.dataset.productPrice.replace(/[.,]/g, "")) || 0;
  const comparePrice =
    Number(this.dataset.productComparePrice.replace(/[.,]/g, "")) || 0;

  const variantButtonsWrapper = card.querySelector(".variant-buttons-scroll");
  if (variantButtonsWrapper) {
    const variants = JSON.parse(this.dataset.variants || "[]");
    variantButtonsWrapper.innerHTML =
      variants.length > 0
        ? variants
            .map(
              (variant) => `
          <button
            type="button"
            class="variant-button ${variant.available ? "" : "soldout"}"
            data-variant-id="${variant.id}"
            ${variant.available ? "" : "disabled"}
          >
            ${variant.title}
          </button>
        `
            )
            .join("")
        : '<p style="color: red;">Sin tallas disponibles</p>';

    variantButtonsWrapper
      .querySelectorAll(".variant-button")
      .forEach((button) => {
        button.removeEventListener("click", handleVariantClick);
        button.addEventListener("click", handleVariantClick);
      });
  }

  card
    .querySelectorAll(".swatch-bolita")
    .forEach((b) => b.classList.remove("active"));
  this.classList.add("active");

  const carousel = card.querySelector(".imagenes_plp");
  if (carousel) {
    destroyCarousel(carousel);
    initializeCarousel(carousel);
  }

  const titleElement = card.querySelector(".card__title a");
  if (titleElement) {
    titleElement.href = productUrl;
    titleElement.textContent = productName;
  }

  const priceContainer = card.querySelector(".product-price");
  if (priceContainer) {
    if (comparePrice > price) {
      const discount = comparePrice - price;
      const discountPercentage = Math.round((discount / comparePrice) * 100);
      priceContainer.innerHTML = `
        <span class="product-price__amount theme-money on-sale">
          $${formatPrice(price)}
        </span>
        <span class="prod-label-inline sale">-${discountPercentage}%*</span>
        <span class="product-price__compare theme-money">
          $${formatPrice(comparePrice)}
        </span>
      `;
    } else {
      priceContainer.innerHTML = `
        <span class="product-price__amount theme-money">$${formatPrice(
          price
        )}</span>
      `;
    }
  }
}

// --- Asigna evento a todos los swatches ---
function assignSwatchListeners() {
  document.querySelectorAll(".swatch-bolita").forEach((bolita) => {
    bolita.removeEventListener("click", swatchClickHandler);
    bolita.addEventListener("click", swatchClickHandler);
  });
}

// --- Asigna evento a botones variantes ---
function assignVariantButtonListeners() {
  document.querySelectorAll(".variant-button").forEach((button) => {
    button.removeEventListener("click", handleVariantClick);
    button.addEventListener("click", handleVariantClick);
  });
}

// --- Función para re-inicializar todo lo necesario tras carga infinita ---
function reInitializeAll() {
  assignSwatchListeners();
  assignVariantButtonListeners();
  assignAddToCartListeners();
  initializeCarousels();
}

// --- Map para almacenar listeners y remover luego ---
const carouselListeners = new WeakMap();

// --- Limpia carrusel y remueve listeners ---
function destroyCarousel(plp) {
  const wrapper = plp.querySelector(".carousel-wrapper");
  if (!wrapper) return;

  while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);

  const btnNext = plp.querySelector(".carousel-btn.next");
  const btnPrev = plp.querySelector(".carousel-btn.prev");

  if (carouselListeners.has(plp)) {
    const {
      nextHandler,
      prevHandler,
      touchstartHandler,
      touchmoveHandler,
      touchendHandler,
    } = carouselListeners.get(plp);

    if (btnNext && nextHandler) btnNext.removeEventListener("click", nextHandler);
    if (btnPrev && prevHandler) btnPrev.removeEventListener("click", prevHandler);
    if (touchstartHandler) wrapper.removeEventListener("touchstart", touchstartHandler);
    if (touchmoveHandler) wrapper.removeEventListener("touchmove", touchmoveHandler);
    if (touchendHandler) wrapper.removeEventListener("touchend", touchendHandler);

    carouselListeners.delete(plp);
  }

  wrapper.style.transition = "none";
  wrapper.style.transform = "translateX(0)";
  plp.removeAttribute("data-carousel-initialized");
}

// --- Inicializa carrusel con loop infinito y touch ---
function initializeCarousel(plp) {
  const wrapper = plp.querySelector(".carousel-wrapper");
  if (!wrapper) return;

  const card = plp.closest(".card");
  const activeSwatch = card ? card.querySelector(".swatch-bolita.active") : null;

  const imageUrls = activeSwatch
    ? JSON.parse(activeSwatch.getAttribute("data-images") || "[]")
    : [];

  if (imageUrls.length === 0) return;

  const productUrl = activeSwatch?.dataset.productUrl || "#";

  imageUrls.forEach((url) => {
    const item = document.createElement("div");
    item.classList.add("carousel-item");
    const a = document.createElement("a");
    a.href = productUrl;
    const img = document.createElement("img");
    img.src = url;
    img.width = 400;
    img.alt = "";
    a.appendChild(img);
    item.appendChild(a);
    wrapper.appendChild(item);
  });

  const items = wrapper.querySelectorAll(".carousel-item");
  const btnNext = plp.querySelector(".carousel-btn.next");
  const btnPrev = plp.querySelector(".carousel-btn.prev");

  let currentIndex = 1;
  const totalItems = items.length;

  if (totalItems === 0) return;

  const firstClone = items[0].cloneNode(true);
  firstClone.classList.add("clone");
  const lastClone = items[totalItems - 1].cloneNode(true);
  lastClone.classList.add("clone");
  wrapper.appendChild(firstClone);
  wrapper.insertBefore(lastClone, items[0]);

  wrapper.style.transform = `translateX(-100%)`;
  wrapper.style.transition = "transform 0.3s ease-in-out";

  function moveCarousel() {
    wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  function nextItem() {
    currentIndex++;
    moveCarousel();
    wrapper.addEventListener("transitionend", handleLoopForward, { once: true });
  }

  function prevItem() {
    currentIndex--;
    moveCarousel();
    wrapper.addEventListener("transitionend", handleLoopBackward, { once: true });
  }

  function handleLoopForward() {
    if (currentIndex === totalItems + 1) {
      wrapper.style.transition = "none";
      currentIndex = 1;
      wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
      setTimeout(() => (wrapper.style.transition = "transform 0.3s ease-in-out"));
    }
  }

  function handleLoopBackward() {
    if (currentIndex === 0) {
      wrapper.style.transition = "none";
      currentIndex = totalItems;
      wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
      setTimeout(() => (wrapper.style.transition = "transform 0.3s ease-in-out"));
    }
  }

  // Touch handlers
  let startX = 0;
  let isDragging = false;

  const touchstartHandler = (e) => {
    startX = e.touches[0].pageX;
    isDragging = true;
  };
  const touchmoveHandler = (e) => {
    if (!isDragging) return;
    const moveX = e.touches[0].pageX - startX;
    if (Math.abs(moveX) > 50) {
      moveX > 0 ? prevItem() : nextItem();
      isDragging = false;
    }
  };
  const touchendHandler = () => {
    isDragging = false;
  };

  wrapper.addEventListener("touchstart", touchstartHandler);
  wrapper.addEventListener("touchmove", touchmoveHandler);
  wrapper.addEventListener("touchend", touchendHandler);

  if (btnNext) btnNext.addEventListener("click", nextItem);
  if (btnPrev) btnPrev.addEventListener("click", prevItem);

  carouselListeners.set(plp, {
    nextHandler: nextItem,
    prevHandler: prevItem,
    touchstartHandler,
    touchmoveHandler,
    touchendHandler,
  });

  plp.setAttribute("data-carousel-initialized", "true");
}

// --- Inicializa todos los carruseles no inicializados ---
function initializeCarousels() {
  document.querySelectorAll(".imagenes_plp").forEach((plp) => {
    if (plp.getAttribute("data-carousel-initialized") !== "true") {
      initializeCarousel(plp);
    }
  });
}

// --- Evento DOMContentLoaded ---
document.addEventListener("DOMContentLoaded", initializeCarousels);

///////////////////////// OBSERVERS CORREGIDOS /////////////////////////

// Observador carga infinita
const filtersResultsContainer = document.querySelector(".filters-results");
if (filtersResultsContainer) {
  const filtersObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        reInitializeAll();
      }
    }
  });
  filtersObserver.observe(filtersResultsContainer, { childList: true, subtree: true });
}

// Observador nodos nuevos con carrusel
const carouselObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          (node.querySelector?.(".imagenes_plp") ||
            node.classList.contains("imagenes_plp"))
        ) {
          initializeCarousels();
        }
      });
    }
  });
});
carouselObserver.observe(document.body, { childList: true, subtree: true });

// Observer cambio filtro (reloadScript)
document.addEventListener("DOMContentLoaded", () => {
  const productList =
    document.querySelector(".filters-results") ||
    document.querySelector(".product-list");

  if (productList) {
    const filterChangeObserver = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          reloadScript();
        }
      }
    });
    filterChangeObserver.observe(productList, { childList: true, subtree: false });
  } else {
    console.warn("No se encontró el contenedor .product-list o .filters-results");
  }
});

// --- El resto de tu código (addToCart, swatch clicks, init, etc.) ---
// Puedes dejarlo tal como estaba, sin cambiar nada más.
